import { Spinner } from '../ui/Spinner';

/** Shown while a lazily-loaded route chunk or the session bootstrap resolves. */
export function RouteFallback({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <div className="grid min-h-[50dvh] place-items-center" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-3 text-ink-muted">
        <Spinner className="size-7 text-brand" />
        <p className="text-sm">{label}</p>
      </div>
    </div>
  );
}

export function FullPageLoader({ label }: { label?: string }) {
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas">
      <RouteFallback {...(label === undefined ? {} : { label })} />
    </div>
  );
}
